import React, { useState, useEffect } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Alert, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import helpers from "./helpers/Utilities";
import constants from './helpers/Constants';

function Pedidos() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const [data, setData] = useState([]);

    const [qtd, setQtd] = useState([]);
    const [obs, setObs] = useState([]);

    const [showMsg, setShowMsg] = useState(false);
    const toggleMsg = () => setShowMsg(!showMsg);

    const [showErr, setshowErr] = useState(false);
    const toggleErr = () => setshowErr(!showErr);

    const handleQtd = (id_produto, value) => {
        qtd[id_produto] = parseInt(value);
        setQtd(qtd);
    };

    const handleObs = (id_produto, value) => {
        obs[id_produto] = value;
        setObs(obs);
    };

    const handleEncomendar = (id_produto) => {
        if(!(id_produto in qtd)){
            toggleErr();
        }
        else{

            let usuario = JSON.parse(localStorage.getItem('usuario_logado'));
            let qtd_pedido = qtd[id_produto];
            let obs_pedido = (id_produto in obs ? obs[id_produto] : '');

            let cmd = `insert into pedido ( id_pedido, id_associado, id_produto, quantidade, obs ) 
            values ( md5(rand()), '${usuario.id_associado}', '${id_produto}', ${qtd_pedido}, '${obs_pedido}' )
            `;
            
            axios({
                method: 'post',
                url: constants.APIURLExec,
                headers: {
                    'APITOKEN': constants.APIToken
                },
                data: {
                    cmd: cmd
                }
            })
            .then(function (response) {
                console.log(response);
                if(response.data.ok){
                    toggleMsg();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
            
            
        }
    };

    useEffect(() => {

        axios({
            method: 'post',
            url: constants.APIURLGet,
            headers: {
              'APITOKEN': constants.APIToken
            },
            data: {
              query: `select * from produto where ativo = 1 order by titulo asc`
            }
        })
        .then(function (response) {
            
            setData(response.data);
            //console.log(response.data);

        })
        .catch(function (error) {
            console.log(error);
        });

    }, []);

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Pedidos</NavbarBrand>
                </Navbar>
                <Container className="pb-5 mb-5">
                    <Modal isOpen={showMsg}>
                        <ModalBody>
                            Pedido enviado com sucesso. Nossa equipe entrará em contato para confirmar.
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleMsg}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={showErr}>
                        <ModalBody>
                            <span className="text-danger">Por favor informe a quantidade e o tamanho (se aplicável) que deseja encomendar.</span>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleErr}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    { data.map((item, i) => 
                    <Row key={item.id_produto} className="mb-5 pb-5">
                        <Col>
                            <Row>
                                <Col className="mt-3">
                                    <h3>{item.titulo}</h3>
                                    <span className="small">
                                        {item.descricao}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <img style={{width: '50%'}} className="my-3" alt='' src={constants.URLUpload + item.foto}></img>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <select className="form-control" onChange={(e) => handleQtd(item.id_produto, e.target.value)} >
                                        <option value="" selected>Quantidade</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                    </select>
                                </Col>
                                <Col>
                                    <input onChange={(e) => handleObs(item.id_produto, e.target.value)} type="text" className="form-control" maxLength="50" placeholder="Tamanho/Obs"></input>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button onClick={() => handleEncomendar(item.id_produto)} className="btn btn-block btn-lg btn-primary btn-azul mt-3">R$ {item.valor_instrutor.toString().replace('.', ',')} - ENCOMENDAR</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
                </Container>
            </div>
        </div>
    );
}

export default Pedidos;
